import {
    FillLayerSpecification,
    FillExtrusionLayerSpecification,
    LineLayerSpecification,
    SymbolLayerSpecification,
    CircleLayerSpecification,
    LayerSpecification,
    ModelLayerSpecification,
    RasterLayerSpecification,
} from "@iventis/mapbox-gl";

type IventisMapboxLayer =
    | FillLayerSpecification
    | FillExtrusionLayerSpecification
    | LineLayerSpecification
    | SymbolLayerSpecification
    | CircleLayerSpecification
    | ModelLayerSpecification
    | RasterLayerSpecification;

interface IventisMapboxLayerMetaDataBase {
    type: "base" | "arrows" | "text" | "model-text" | "outline" | "highlight" | "model" | "sitemap" | "stand-base" | "stand-stem" | "map-background" | "guide-line";
}

export interface IventisMapboxLayerMetaDataUserLayer extends IventisMapboxLayerMetaDataBase {
    name: string;
    type: "base" | "arrows" | "text" | "model-text" | "outline" | "highlight" | "model" | "stand-base" | "stand-stem" | "guide-line";
}

export type IventisMapboxTestLayer = IventisMapboxLayer & { metadata?: IventisMapboxLayerMetaDataUserLayer };

export interface IventisMapboxLayerMetaDataSitemapLayer extends IventisMapboxLayerMetaDataBase {
    sitemapName: string;
    sitemapVersionName: string;
    levelIndex: number;
    type: "sitemap";
}

export interface IventisMapboxLayerMetaDataMapBackgroundLayer extends IventisMapboxLayerMetaDataBase {
    mapBackgroundName: string;
    type: "map-background";
}

export function isIventisUserLayer(layer: LayerSpecification): layer is IventisMapboxLayer & { metadata: IventisMapboxLayerMetaDataUserLayer } {
    if (layer == null || layer.metadata == null || typeof layer.metadata !== "object") {
        return false;
    }

    const metadata = layer.metadata as Record<string, unknown>;
    const hasName = typeof metadata.name === "string";
    return hasName;
}

export function isIventisSitemapLayer(layer: LayerSpecification): layer is IventisMapboxLayer & { metadata: IventisMapboxLayerMetaDataSitemapLayer } {
    if (layer == null || layer.metadata == null || typeof layer.metadata !== "object") {
        return false;
    }
    const metadata = layer.metadata as Record<string, unknown>;
    return metadata.type === "sitemap" && typeof metadata.sitemapName === "string" && typeof metadata.sitemapVersionName === "string";
}

export function isIventisBackgroundLayer(layer: LayerSpecification): layer is IventisMapboxLayer & { metadata: IventisMapboxLayerMetaDataMapBackgroundLayer } {
    if (layer == null || layer.metadata == null || typeof layer.metadata !== "object") {
        return false;
    }
    const metadata = layer.metadata as Record<string, unknown>;
    return metadata.type === "map-background" && typeof metadata.mapBackgroundName === "string";
}
